import { Service } from '@/request/http.js'

// 酒店列表-左侧价格范围
export function hotelCurrency (data) {
  return Service({
    url: '/api/hotelCurrency',
    method: 'post',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/request/currency.js